import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom/dist";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { Filter, PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../../components/toaster/Toaster";
import { deleteAlert } from "../../components/sweetAlert";
import { cleanObject, Debounce } from "../../../utils";
import { all_routes } from "../../../Router/all_routes";
import ProductServices from "../../../services/Product";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Controller, useForm } from "react-hook-form";
import BrandServices from "../../../services/Brand";
import CategoryServices from "../../../services/Category";
import { Select } from "antd";

const Products = () => {

  const routes = all_routes;
  const [searchParams, setSearchParams] = useSearchParams();

  const { handleSubmit, control, setValue } = useForm();

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Brands
  const [brands, setBrands] = useState([]);

  // *For Categories
  const [categories, setCategories] = useState([]);

  // *For Products
  const [products, setProducts] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const pageLimit = parseInt(searchParams.get("limit") || "10", 10);
  const searchText = searchParams.get("search") || "";

  // *For Filter
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BrandServices.getBrands(params)
      setBrands(data.map((e) => { return { label: e?.name, value: e?.id } }))
    } catch (error) {
      console.log('getBrands => error:', error)
    }
  }

  // *For Get Categories
  const getCategories = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await CategoryServices.getCategories(params)
      setCategories(data.map((e) => { return { label: e?.name, value: e?.id } }))
    } catch (error) {
      console.log('getCategories => error:', error)
    }
  }

  // *For Get Products
  const getProducts = async (page = currentPage, limit = pageLimit) => {
    setLoader(true)
    try {
      const params = { ...Object.fromEntries(searchParams.entries()), page, limit }
      const { data, total_count } = await ProductServices.getProducts(params)
      setProducts(data)
      setTotalCount(total_count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete Product
  const deleteProduct = async (id) => {
    try {
      const isConfirmed = await deleteAlert()

      if (isConfirmed) {
        await ProductServices.deleteProduct(id);
        getProducts();

        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.close();
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const columns = [
    {
      title: "Product Name",
      dataIndex: "name",
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },

    {
      title: "Brand",
      dataIndex: "brand",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_active",
      render: (active) => (
        <Fragment>
          {active ? (
            <span className="badge badge-linesuccess">
              Active
            </span>
          ) : (
            <span className="badge badge-linedanger">
              Inactive
            </span>
          )}
        </Fragment>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to={`${routes?.editProduct}/${record?.id}`}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" to="#" onClick={() => deleteProduct(record?.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // *For Handle Pagination and Filters
  const handlePaginationFilter = (data) => {
    try {
      const updatedParams = {
        ...Object.fromEntries(searchParams.entries()),
        page: 1,
        ...cleanObject(data)
      };
      Debounce(() => setSearchParams(updatedParams));
    } catch (error) {
      console.log(' handlePaginationFilter => error:', error)
    }
  }

  useEffect(() => {
    getProducts()
    if (searchParams) {
    }
  }, [searchParams]);

  useEffect(() => {
    getBrands()
    getCategories()
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Product</h4>
                <h6>Manage your products</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to={routes?.createProduct}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Product
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      defaultValue={searchText}
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handlePaginationFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <div
                    className={`btn btn-filter cursor-pointer ${isFilterVisible ? "setclose" : ""}`}
                    id="filter_search"
                    onClick={() => setIsFilterVisible((prev) => !prev)}
                  >
                    <Filter
                      className="filter-icon"
                    />
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {isFilterVisible &&
                <div className={`border-0 card${isFilterVisible ? " visible" : ""}`} >
                  <div className="card-body pb-0 px-4">
                    <form onSubmit={handleSubmit(handlePaginationFilter)}>
                      <div className="row align-items-center">
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="mb-1 add-product">
                            <label className="form-label">Brand</label>
                            <Controller
                              control={control}
                              name={'brand'}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  size="large"
                                  style={{ width: '100%' }}
                                  options={brands}
                                  onChange={(value) => field.onChange(value)}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="mb-1 add-product">
                            <label className="form-label">Category</label>
                            <Controller
                              control={control}
                              name={'category'}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  size="large"
                                  style={{ width: '100%' }}
                                  options={categories}
                                  onChange={(value) => field.onChange(value)}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                          <div className="input-blocks mb-1">
                            <button type="submit" className="btn btn-filters ms-auto">
                              <i
                                data-feather="search"
                                className="feather-search"
                              />
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              }

              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={products}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => handlePaginationFilter({ page: page, limit: pageSize })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
